module.exports = __webpack_public_path__ + "img/logo_small.56ed9ba4.svg";